const STORAGE_KEY = 'localas.login.username';
const LEGACY_STORAGE_KEY = 'localas.login.credentials';

export const loadSavedUsername = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'string') {
        return parsed;
      }
      return parsed.username ?? '';
    }

    const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (!legacy) {
      return '';
    }

    const legacyParsed = JSON.parse(legacy);
    const username = legacyParsed.username ?? '';
    if (username) {
      saveUsername(username);
    }
    localStorage.removeItem(LEGACY_STORAGE_KEY);
    return username;
  } catch {
    return '';
  }
};

export const saveUsername = (username) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(username));
};
